var _style, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWardLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1760px",
    height: "530px",
    viewBox: "0 0 1760 530",
    style: {
      enableBackground: "new 0 0 1760 530"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(352.050773, 1026.993894)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M661.26-875.66L579.1-588.33h-31.96l-66.71-219.14c-0.64-2.16-1.24-4.43-1.79-6.83 c-0.54-2.4-1.12-4.93-1.72-7.63c-0.61,2.7-1.23,5.23-1.83,7.63c-0.61,2.4-1.23,4.67-1.83,6.83l-67.08,219.14h-32l-82.12-287.32 h29.58c3.17,0,5.83,0.88,7.98,2.64c2.14,1.74,3.52,3.93,4.14,6.59l54.41,199.68c0.85,3.62,1.67,7.51,2.45,11.66 c0.81,4.13,1.57,8.54,2.31,13.22c0.85-4.68,1.74-9.13,2.67-13.34c0.92-4.2,1.94-8.05,3.04-11.54l61.91-199.68 c0.75-2.26,2.2-4.36,4.32-6.31c2.14-1.94,4.76-2.92,7.84-2.92h10.29c3.17,0,5.73,0.88,7.69,2.64c1.98,1.74,3.45,3.93,4.43,6.59 l61.77,199.68c1.1,3.5,2.1,7.25,3,11.26c0.92,3.99,1.81,8.21,2.67,12.62c0.6-4.41,1.28-8.63,2.01-12.62 c0.75-4.01,1.56-7.77,2.42-11.26l54.59-199.68c0.6-2.4,1.98-4.52,4.1-6.39c2.14-1.89,4.76-2.84,7.84-2.84H661.26z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(514.476772, 1026.993894)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M678-694.98L636.66-811.9c-1.23-3.46-2.52-7.49-3.88-12.1c-1.35-4.63-2.63-9.55-3.84-14.74 c-2.56,10.82-5.2,19.83-7.91,27.04l-41.34,116.72H678z M752.25-588.33h-27.57c-3.18,0-5.75-0.86-7.73-2.6 c-1.96-1.76-3.42-3.96-4.39-6.63l-24.64-69.38H569.77l-24.64,69.38c-0.73,2.4-2.14,4.54-4.21,6.43c-2.08,1.87-4.65,2.8-7.73,2.8 h-27.57l105.3-287.32h36.03L752.25-588.33z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(620.669344, 1026.993894)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M753.75-736.49c10.3,0,19.39-1.37,27.28-4.11c7.91-2.74,14.52-6.61,19.84-11.62 c5.35-5.03,9.35-11.02,12.05-17.98c2.71-6.95,4.06-14.63,4.06-23.05c0-17.1-5.15-29.98-15.45-38.67 c-10.28-8.71-25.72-13.06-46.32-13.06h-38.96v108.49H753.75z M875.41-588.33h-31.6c-6.5,0-11.28-2.74-14.35-8.23L761.1-699.22 c-2.08-3.2-4.31-5.49-6.7-6.91c-2.4-1.41-6.11-2.12-11.13-2.12h-27.02v119.91h-35.44v-287.32h74.4c16.67,0,31.07,1.84,43.2,5.51 c12.13,3.67,22.13,8.99,30.02,15.94c7.91,6.95,13.77,15.34,17.57,25.17c3.81,9.83,5.71,20.83,5.71,32.99 c0,10.15-1.48,19.64-4.43,28.48c-2.93,8.82-7.19,16.74-12.78,23.77c-5.57,7.01-12.37,12.98-20.39,17.94 c-8.04,4.93-17.13,8.67-27.28,11.22c4.54,2.8,8.46,6.87,11.75,12.22L875.41-588.33z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(718.940601, 1026.993894)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1041.06-731.89c0,21.52-3.13,41.1-9.37,58.76c-6.25,17.64-15.08,32.73-26.47,45.3 c-11.4,12.57-25.1,22.31-41.08,29.2c-15.99,6.87-33.67,10.31-53.02,10.31h-98.31v-287.32h98.31c19.35,0,37.02,3.46,53.02,10.35 c15.98,6.87,29.67,16.64,41.08,29.28c11.4,12.62,20.22,27.76,26.47,45.42C1037.93-772.98,1041.06-753.4,1041.06-731.89z  M1004.48-731.89c0-17.66-2.22-33.43-6.63-47.33c-4.39-13.9-10.65-25.65-18.75-35.27c-8.08-9.61-17.89-16.96-29.4-22.05 c-11.52-5.08-24.38-7.63-38.59-7.63h-62.68v224.37h62.68c14.21,0,27.07-2.54,38.59-7.63c11.51-5.08,21.32-12.39,29.4-21.93 c8.1-9.56,14.35-21.29,18.75-35.19C1002.27-698.46,1004.48-714.24,1004.48-731.89z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 530,
    y1: 306.1057,
    x2: 9.094947e-13,
    y2: 306.1057
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3772B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9AD9E9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.15,486.36c-99.12-49.28-158.9-115.58-195.88-213.59C0.62,236.6-5.48,196.76,6.12,160 s43.52-69.51,84.36-76.58c40.84-7.07,87.52,17.55,94.53,55.29c14.27,76.81,99.98,136.15,184.03,127.42 c64.79-6.73,131.86,32.07,153.42,88.76c21.56,56.69-4.56,125.58-59.74,157.57S299.69,530.88,210.15,486.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.9519,
    y1: 119.7211,
    x2: 521.7543,
    y2: 119.7211
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3772B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9AD9E9"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M253.94,180.76c-23.84-21.93-42.99-49.34-48.51-79.95s4.38-64.51,30.05-84.6s67.55-22.48,92.51-1.64 c35.55,29.69,81.06,49.12,128.63,54.91c34.76,4.23,62.22,34.5,64.89,66.71s-16.92,64.09-45.86,82.34s-65.87,23.79-100.64,19.59 S302.6,225.52,253.94,180.76z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWardLogo);
export default __webpack_public_path__ + "static/media/wardLogo.618ccd639394a6f3d0f355add60f6ba3.svg";
export { ForwardRef as ReactComponent };